export default __webpack_public_path__ + "static/media/project-menu.672fa3dc.png";